module.exports = __webpack_public_path__ + "static/ms-icon-144x144-03177237ad0cf4f9bd11d2988fecb0bf.png";